import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, EMPTY, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContentPagesService } from '../state/content-pages/content-pages.service';
import { ContentPage } from '../state/content-pages/content-page.model';

@Injectable({ providedIn: 'root' })
export class ContentPageResolver implements Resolve<ContentPage | null> {
  constructor(
    private contentPagesService: ContentPagesService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<ContentPage | null> {
    // Get the full path from the URL
    const path = '/' + route.url.map(segment => segment.path).join('/');
    
    // Try to resolve the page
    return this.contentPagesService.resolveByPath(path).pipe(
      map(page => {
        // Only return the page if it's published
        if (page && page.isPublished) {
          return page;
        }
        // If not published, treat as not found
        this.router.navigate(['/404']);
        return null;
      }),
      catchError(error => {
        // If page not found or any error, navigate to 404
        console.error('Failed to resolve content page:', error);
        this.router.navigate(['/404']);
        return of(null);
      })
    );
  }
}